import { render, staticRenderFns } from "./MobileContent.vue?vue&type=template&id=53443af2&scoped=true&"
import script from "./MobileContent.vue?vue&type=script&lang=ts&"
export * from "./MobileContent.vue?vue&type=script&lang=ts&"
import style0 from "./MobileContent.vue?vue&type=style&index=0&id=53443af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53443af2",
  null
  
)

export default component.exports